import React from 'react';
import './App.css';
import RecordsLib from './components/recordsLib'
import reduxStore from './redux/store';
import { Provider } from 'react-redux';
function App() {
  return (
    <Provider store={reduxStore}>
    <div className="App">
      <RecordsLib />
    </div>
    </Provider>
  );
}

export default App;
